/**
 * Handles the 'Move to Wishlist' button in the mini cart and cart page.
 */

import { addProductToWishlist, getWishlists } from "@app/scripts/api/wishlist"
import { selectDefaultWishlist } from "@app/scripts/utils"
import { IWishlist } from "@app/types/wishlist"

const owner = window.ShopifyAnalytics.meta.page.customerId?.toString() || null
let wishlist: IWishlist | null = null

const processWishlistButtons = () => {
  const moveToWishlistButtons = document.querySelectorAll<HTMLButtonElement>(
    ".cart__move-to-wishlist"
  )

  moveToWishlistButtons.forEach((button) => {
    if (button.dataset.init === "true") return
    button.dataset.init = "true"
    button.dataset.requireLogin = owner ? "false" : "true"
    button.addEventListener("click", (e) => {
      if (!owner) {
        e.preventDefault()
        window.location.href =
          "/account/login?return_url=" +
          encodeURIComponent(window.location.pathname)
        return
      }

      if (!wishlist) {
        console.error("No wishlist found")
        return
      }
      const productId = button.dataset.productId || ""
      const variantId = button.dataset.variantId || ""

      console.assert(
        productId && variantId,
        "Product ID or variant ID not found."
      )

      addProductToWishlist({
        owner,
        product_id: productId,
        variant_id: variantId,
        wishlist_ids: [wishlist.id],
      })
    })
  })
}

document.addEventListener("DOMContentLoaded", async () => {
  if (owner) {
    const wishlists = await getWishlists(owner, true)
    wishlist = selectDefaultWishlist(wishlists?.wishlists || [])
    console.assert(wishlist, "No default wishlist found for the current owner.")
  }

  processWishlistButtons()

  // Observe for dynamically added buttons
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const elementNode = node as Element
            const buttonsToProcess: HTMLElement[] = []

            // Check if the added node itself is a wishlist button
            if (elementNode.matches(".cart__move-to-wishlist")) {
              buttonsToProcess.push(elementNode as HTMLElement)
            }

            // Also check for wishlist buttons within added subtrees
            const newButtonsInSubtree =
              elementNode.querySelectorAll<HTMLElement>(
                ".cart__move-to-wishlist"
              )
            if (newButtonsInSubtree.length > 0) {
              // Add only unique cards
              Array.from(newButtonsInSubtree).forEach((newCard) => {
                if (!buttonsToProcess.includes(newCard)) {
                  buttonsToProcess.push(newCard)
                }
              })
            }

            if (buttonsToProcess.length > 0) {
              processWishlistButtons()
            }
          }
        })
      }
    }
  })

  observer.observe(document.body, { childList: true, subtree: true })
})
